import { render, staticRenderFns } from "./dingzhiOrderDetail.vue?vue&type=template&id=3f164330&scoped=true&"
import script from "./dingzhiOrderDetail.vue?vue&type=script&lang=js&"
export * from "./dingzhiOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./dingzhiOrderDetail.vue?vue&type=style&index=0&id=3f164330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f164330",
  null
  
)

export default component.exports